export enum scheduletemplate {
  priornotification = 1,
  overduenotification=2
}

export const scheduletemplate2LabelMapping = {
  [scheduletemplate.priornotification]: "Complete Form Notification",
  [scheduletemplate.overduenotification]: "Past Due Notification",
}
